import { ESdChangeReason, LeftPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import { isLeftPanelButtonActive } from "./left-panel-rail";

export interface ActionTreeButtonState {}

export interface ActionTreeButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class ActionTreeButton extends PureSdComponent<ActionTreeButtonProps & IWithSDProps, ActionTreeButtonState> {
  constructor(props: ActionTreeButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick(LeftPanelType.ActionTree);
    } else {
      this.props.sd.setActiveLeftPanelByClick(LeftPanelType.ActionTree);
    }
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.ActionTreeButton) === Visibility.Visible && (
          <KuikaButton
            data-testid="leftMenuActionTreeTabButton"
            data-onboarding-id="left_menu_action-tree"
            type="tertiary"
            size="md"
            isIcon
            color="neutral"
            active={isLeftPanelButtonActive(this.props.sd, LeftPanelType.ActionTree)}
            onClick={this.handleClick}
          >
            <KuikaSvg name="lightning" width={24} height={24} pointer style={{ minWidth: 24 }} />
          </KuikaButton>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const actionTreeButton = withSD<ActionTreeButtonProps>(ActionTreeButton);
export { actionTreeButton as ActionTreeButton };
